module.exports = __webpack_public_path__ + "static/media/7.e91ab63a.jpg";